'use strict';

/**
 * Wraps the
 * @param {String} text haystack to search through
 * @param {String} search needle to match
 */

module.exports = highlightFilter;

function highlightFilter($sce) {
  return function (text, search) {

    if (!text) {
      return text;
    }

    if (search || search === 0) {
      var tpl = '<span class="search-match highlight">$&</span>';
      text = text.toString();
      search = search.toString();
      search = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); // Scape characters
      text = text.replace(new RegExp(search, 'gi'), tpl);
    }

    return $sce.trustAsHtml(text);
  };
}



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/filter/es5/filters/highlightFilter.js